import { useRef } from 'react'

import arrow_up from '../../assets/icons/arrow_up.png'
import './TopButton.css'

const TopButton = () => {

    const btnRef = useRef()
    window.onscroll = () => {

        const btn = btnRef.current;
        if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
            btn.style.display = "block";
        } else {
            btn.style.display = "none";
        }
    }

    const goToTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return <button ref={btnRef} className='btn shadow-lg scroll-btn' onClick={goToTop}>
        <img src={arrow_up} alt="top" style={{ height: '30px', width: '30px' }} />
    </button>
}

export default TopButton